<template>
  <div>
    <div
        id="account-aria-live"
        aria-live="assertive"
        class="coh-style-screen-reader-only"
    ></div>
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <Message />
    <router-view />
    <ScrollToTop />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VueElementLoading from 'vue-element-loading';
import { useAppStore } from '@/store/app.store';
import Message from '@/components/Message.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';

const isLoading = computed(() => {
  const appStore = useAppStore();
  return appStore.isLoading;
});
</script>

<style scoped>
  /*@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css");*/
  /*@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css");*/
@font-face {
  font-family: Campton-Bold;
  src: local('/fonts/Campton-Bold.woff2');
}

#app {
  font-family: "Proxima Nova", sans-serif;
}

.velmld-spinner {
  top: 16.6rem !important;
}

button {
  border-radius: 3px;
  display: inline-block;
  padding: 0 1em;
  margin: 0.25rem;
  line-height: 40px;
  font-size: 1.125em;
  height: 40px;
  border: 1px solid #dadada;
  text-transform: none !important;
}

.coh-style-button, .coh-style-button-white {
  background-color: rgb(255,255,255);
  border-radius: 3px;
  line-height: 36px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
}

.active {
  color: rgb(255,255,255);
  background-color: rgb(0,157,220);
}

.coh-style-button-blue-solid {
  background-color: rgb(35,97,146);
  border-radius: 3px;
  line-height: 36px;
  text-align: center;
  display: inline-block;
  margin: 0.5rem 0;
  color: rgb(255,255,255);
  border-width: 2px;
  border-style: solid;
  border-color: rgb(35,97,146);
}
</style>
<style>
header a {
  text-decoration: none;
}
</style>
